import React, { Component } from "react";
import { Col, Container, Row, Badge, Button, Table } from 'reactstrap';
import { withRouter, } from "react-router-dom";
import moment from 'moment'
import Modal from 'react-modal'
import TimeAgo from 'react-timeago'
import spanishStrings from 'react-timeago/lib/language-strings/es'
import buildFormatter from 'react-timeago/lib/formatters/buildFormatter'
import Loader from "react-loader-spinner";
import { faPlus,faFile,faUser} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

// import matchSorter from "match-sorter";
import TableFilter from "react-table-filter";
import "react-table-filter/lib/styles.css";


const URL = 'https://hg.wsoft.com.mx/REST/controllers/'
const formatter = buildFormatter(spanishStrings)
const customStyles = { content : {top: '55%',left: '50%',right: 'auto',bottom: 'auto',marginRight: '-50%',transform: 'translate(-50%, -50%)',width: '90%',height: '90%',} };
class RHContadorPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      arrSucursales: [
        {id_sucursal: '', nombre: 'DIRECCIÓN', label: 'DIRECCIÓN', value: 'DIRECCIÓN', },
        {id_sucursal: '5f2067c915291', nombre: 'BELLAVISTA', label: 'BELLAVISTA', value: 'BELLAVISTA', },
        {id_sucursal: '5f206899a20c8', nombre: 'INGENIO', label: 'INGENIO', value: 'INGENIO', },
        {id_sucursal: '5f2071cb03380', nombre: 'ECOCENTRAL', label: 'ECOCENTRAL', value: 'ECOCENTRAL', },
        {id_sucursal: '5f2071cb0ww32', nombre: 'RUTA', label: 'RUTA', value: 'RUTA', },
        {id_sucursal: '5f2073022efb6', nombre: 'MADERO', label: 'MADERO', value: 'MADERO', },
        {id_sucursal: 'almacen', nombre: 'ALMACEN', label: 'ALMACEN', value: 'ALMACEN', },
        {id_sucursal: '5f2067c914482', nombre: 'GMART', label: 'GMART', value: 'GMART', },
        {id_sucursal: 'madero2', nombre: 'MADERO 2', label: 'MADERO 2', value: 'MADERO 2', },
      ],
      date: moment().format('YYYY-MM-DD'),
      dateCaja: moment().format('YYYY-MM-DD'),
      view: 'view_financieros', // view_cortes
      arrayListFacturas: [],
      indexFactura: 0,
      arrayListCajeros: { list: [], sucursales_disponibles: [] },
      arrayListCaja: {list: [], cajeros: [],},


      // New
      isLoading: false,
      isOpenModal: false,
      arrClientes: [],
      infoModal: { title: '', data: [], },

      finit: moment().startOf('month').format('YYYY-MM-DD'),
      ffin: moment().endOf('week').format('YYYY-MM-DD'),

      arrGastosFinancieros: [],
      arrGFinancieroNew: {
        date: moment().format('YYYY-MM-DD'),
      },
      arrConceptosGFinancieros: [],
    }

    this._filterUpdatedGF = this._filterUpdatedGF.bind(this);
  }

  _filterUpdatedGF(newData, filtersObject) {
    this.setState({
      arrGastosFinancieros: newData
    });
  }

  componentDidMount() {
    //Petition wuuuu
    // this.getListFacturacion()
    // this.getListCajeros()
    // this.generateListCaja(this.state.dateCaja)
    this.getGastosFinancieros()
    this.props.onRef(this)
  }

  render() {
    const {
      arrayListFacturas,
      isLoading,
    } = this.state

    return (
      <>
        <div className="initialPage__wrapper" style={{ backgroundColor: 'transparent', }}>
          {/* Principal Container */}
          <div style={{ background: '#b71540', height: 190, overflow: 'hidden', position: 'absolute', top: 0, left: 0, right: 0, zIndex: 1, }} >
            <Container>
              <Row className={'facturacionHeader__row'}>
                <Col xs={'2'}>
                  <img alt={"img"} src={'img/hgapp/logohg.png'} className={'facturacionHeader__profile'} />
                </Col>
                <Col className={'facturacionHeader__description'}>
                  <p>ADMINISTRACIÓN<br /><span>Carnicerías Hermanos González</span></p>
                </Col>
              </Row>
            </Container>
          </div>
          <div style={{ height: '50px', width: '80%', margin: '0 auto', marginTop: '150px', }}>
            <div>
              <Row>
                <Col>
                  <Button 
                  className={'btn btn-sm altasModule__btnAction'}
                    onClick={
                      () => {
                        this.setState({
                          view: 'view_cortes'
                        }, this.generateListCaja)
                      }
                    }
                  ><FontAwesomeIcon icon={faUser} /> Cortes de caja</Button>
                  <Button 
                    onClick={
                      () => {
                        this.setState({
                          view: 'list_facturas'
                        }, this.getListFacturacion)
                      }
                    }
                    className={'btn btn-sm altasModule__btnAction'}
                  ><FontAwesomeIcon icon={faFile} /> Facturas</Button>&nbsp;
                  <Button 
                  className={'btn btn-sm altasModule__btnAction'}
                    onClick={
                      () => {
                        this.setState({
                          view: 'view_cajeros'
                        }, this.getListCajeros)
                      }
                    }
                  ><FontAwesomeIcon icon={faUser} /> Cajeros</Button>&nbsp;
                  <Button 
                  className={'btn btn-sm altasModule__btnAction'}
                    onClick={
                      () => {
                        this.setState({
                          view: 'view_activity'
                        }, this.getProgresoByDay)
                      }
                    }
                  ><FontAwesomeIcon icon={faUser} /> Actividades de cajeros</Button>
                  <Button 
                  className={'btn btn-sm altasModule__btnAction'}
                    onClick={
                      () => {
                        this.setState({
                          view: 'view_financieros'
                        }, this.getGastosFinancieros)
                      }
                    }
                  ><FontAwesomeIcon icon={faUser} /> Gastos financieros</Button>
                </Col>
              </Row>
            </div>
          </div>
          {
            isLoading ?
            <Row style={{ margin: '0 auto', width: '100%', justifyContent: 'center', alignItems: 'center', display: 'flex', }}>
              <Loader
                type="Puff"
                color="#00BFFF"
                height={100}
                width={100}
                timeout={0} //3 secs
              />
            </Row>
            : <div style={{ width: '80%', margin: '0 auto', }}>
              {this.state.view === 'view_cortes' ? this.makeViewCaja() : null}
              {this.state.view === 'list_facturas' ? this.makeViewFacturas() : null}
              {this.state.view === 'factura_view' ? this.makeViewFacturaInformation() : null}
              {this.state.view === 'view_cajeros' ? this.makeViewCajeros() : null}
              {this.state.view === 'view_activity' ? this.makeViewActivity() : null}
              {this.state.view === 'view_financieros' ? this.makeViewFinancieros() : null}
            </div>
          }
        </div>
      </>
    );
  }

  makeViewCajeros() {
    const { arrayListCajeros } = this.state;
    return (
      <Container>
        <Row>
          <Col>
            <div className=" ws_tabs_cajero">
              <div style={{ background: '#fff', padding: '15px' }} className="z-depth-1">
                <Table striped bordered>
                  <thead>
                    <tr>
                      <td>NOMBRE</td>
                      <td>SUCURSAL</td>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      arrayListCajeros.list.map((t, e) => (
                        <tr>
                          <td>{t.nombre}</td>
                          <td>
                            <select
                              className="form-control"
                              key={e}
                              onChange={
                                (e) => {
                                  const { nombre, id_sucursal } = arrayListCajeros.sucursales_disponibles[e.target.value]
                                  console.log("valores", nombre, id_sucursal)

                                  if (window.confirm(`¿Deseas cambiar el usuario: ${t.nombre} a la sucursal ${nombre} ?`)) {
                                    this.updateSucursalCajero(id_sucursal,t.id_usuario);
                                  } else {
                                    console.log("cancelar cambio")
                                  }
                                }
                              }
                            >
                              {
                                arrayListCajeros.sucursales_disponibles.map((value, index) => (
                                  <option key={index} value={index} selected={t.id_sucursal == value.id_sucursal ? 'selected' : ''} >
                                    {value.nombre}
                                  </option>
                                ))
                              }
                            </select>
                          </td>
                        </tr>
                      ))
                    }
                  </tbody>
                </Table>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    )
  }

  makeViewCaja() {
    const { arrayListCaja, dateCaja, } = this.state;
    return (
      <div>
        <Row>
          <Col>
            <div className=" ws_tabs_cajero">
              <div style={{ background: '#fff', padding: '15px' }} className="z-depth-1">

                <input type={"date"}
                  value={dateCaja}
                  onChange={(event) => {
                    this.setState({
                      dateCaja: event.target.value
                    }, this.generateListCaja)
                  }}
                  style={{background: '#f3f3f3', border: '3px solid #F3F3F4', margin: 0, width: '100%', }}
                />
                <Table striped bordered>
                  <thead>
                    <tr>
                      <td>NOMBRE</td>
                      <td>CONCEPTO</td>
                      <td>OBSERVACION</td>
                      <td>MONTO</td>
                      <td>FECHA</td>
                      <td>ACCIONES</td>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      arrayListCaja.list.map((t, e) => (
                        <tr key={e}>
                          <td>
                            {
                              t.id_motivo !== 6 ? (
                                <select className="form-control" key={e}
                                  onChange={ (event) => {
                                    arrayListCaja.list[e].changes = true
                                    arrayListCaja.list[e].id_usuario_change = event.target.value
                                    this.setState({ arrayListCaja, })
                                  }}
                                >
                                  {
                                    arrayListCaja.cajeros.map((t0,e0) => (
                                      <option key={e0} selected={t0.id_usuario === t.id_usuario ? true : false} value={t0.id_usuario}>{t0.nombre} ({t0.sucursal})</option>
                                    ))
                                  }
                                </select>
                              ) : <p>{t.nombre}</p>
                            }
                          </td>
                          <td>{this.makeConceptoCaja(t.id_motivo)}</td>
                          <td>{t.observacion}</td>
                          <td>${this.number_format(t.valor,2)}</td>
                          <td>
                            {
                              t.id_motivo !== 6 ? (
                                <input
                                  type={'datetime-local'}
                                  value={moment(t.fecha_corte).format('YYYY-MM-DDTHH:mm')}
                                  onChange={ (event) => {
                                    arrayListCaja.list[e].changes = true
                                    console.log(event.target.value)
                                    arrayListCaja.list[e].fecha_corte = event.target.value
                                    this.setState({ arrayListCaja, })
                                  }}
                                />
                              ) : <p>{moment(t.fecha_corte).format('DD/MM/YYYY HH:mm')}</p>
                            }
                          </td>
                          <td>
                            {
                              t.changes ? (
                                <button
                                  onClick={() => {
                                    if (window.confirm(`¿Estás seguro que deseas realizar el este cambio?`)) {
                                      console.log(t)
                                      // this.setChangeCaja(t, e)
                                    }
                                  }}
                                  className={'btn btn-primary'}
                                >Realizar cambios</button>
                              ) : null
                            }
                            {
                              t.id_motivo !== 6 ? (
                                <button
                                  onClick={() => {
                                    if (window.confirm(`¿Estás seguro que deseas ELIMINAR este registro de caja?`)) {
                                      this.setDeleteCajaRH(t, e)
                                    }
                                  }}
                                  className={'btn btn-danger'}
                                >Eliminar</button>
                              ) : null

                            }
                          </td>

                          
                        </tr>
                      ))
                    }
                  </tbody>
                </Table>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    )
  }


  getProgresoByDay() {
    const { date, } = this.state
    const data = { date, }
    this.setState({ isLoading: true, })

    fetch("https://hg.wsoft.com.mx/REST/controllers/controllerWebApp.php?opt=getMovimientosCajerosByDay", this.headersPOST({ ...data, }))
    .then(response => response.json())
    .then((response) => {
      this.setState({ arrClientes: response, isLoading: false, })
    })
  }

  openModalByType( type, item ) {
    let infoModal = {
      title: type.toUpperCase(),
      data: {},
    }
    this.setState({
      isOpenModal: true,
      infoModal,
    })
    if(type === 'ventas') {
      setTimeout(() => {
        const { date, } = this.state
        const data = { date, id_usuario: item.id_usuario }
        fetch("https://hg.wsoft.com.mx/REST/controllers/controllerWebApp.php?opt=getMovimientosVentasByDate", this.headersPOST({ ...data, }))
        .then(response => response.json())
        .then((response) => {
          infoModal.data = response
          this.setState({ infoModal, })
        })
      }, 1000)
    } else if(type === 'cortes') {
      infoModal.data = item.cortes
      this.setState({ infoModal, })
    } else if(type === 'mermas') {
      infoModal.data = item.mermas
      this.setState({ infoModal, })
    } else if(type === 'traspasos') {
      infoModal.data = item.traspasos
      this.setState({ infoModal, })
    } else if(type === 'devoluciones') {
      infoModal.data = item.devoluciones
      this.setState({ infoModal, })
    }
  }

  makeViewActivity() {
    const { date, arrClientes, infoModal, } = this.state;

    return (
      <div style={{ background: '#fff', borderRadius: 4, padding: 10, }}>
        <Row>
          <Col>
            <div className="directorPage__wrapper"  style={{ paddingBottom: 20, background: 'transparent', position: 'inherit', zIndex: 0, }}>
              <p className="regVentaPage__productGeneral" style={{ padding: 0, margin: 0, }}>VISTA PROGRESO DEL DÍA POR CAJERO</p>
              
              <Row>
                <Col>
                  <p style={{ margin: 0, }}>Fecha</p>
                  <input type={"date"}
                    value={date}
                    onChange={(event) => {
                      this.setState({ date: event.target.value });
                    }}
                    style={{background: '#f3f3f3', border: '3px solid #F3F3F4', margin: 0, width: '100%', }}
                  />
                  <button onClick={() => { this.getProgresoByDay() }} style={{ margin: 0, marginTop: 5, border: 0, background: 'rgb(183, 21, 64)', color:'#fff' }}>Generar</button>
                </Col>
              </Row>

              <div className="table-responsive">
                <Table className="table table-sm table-striped mt-2">
                  <thead>
                    <tr>
                      <th>Cajero</th>
                      <th style={{ textAlign: 'center', }}>Ventas</th>
                      <th style={{ textAlign: 'center', }}>Cortes</th>
                      <th style={{ textAlign: 'center', }}>Mermas</th>
                      <th style={{ textAlign: 'center', }}>Devoluciones</th>
                      <th style={{ textAlign: 'center', }}>Traspasos</th>
                    </tr>
                  </thead>
                  <tbody>
                  {
                    arrClientes.length > 0 && arrClientes.map((t,e) => (
                      <tr>
                        <th>
                          <p style={{ margin: 0, }}>{t.nombre}</p>
                          <p style={{ margin: 0, fontSize: '.6rem', color: '#777', fontWeight: 300, }}>{t.sucursal}</p>
                        </th>
                        <th onClick={() => { this.openModalByType('ventas', t) }} style={{ textAlign: 'center', }}>{Object.keys(t.ventas).length}</th>
                        <th onClick={() => { this.openModalByType('cortes', t) }} style={{ textAlign: 'center', }}>{t.cortes.length}</th>
                        <th onClick={() => { this.openModalByType('mermas', t) }} style={{ textAlign: 'center', }}>{Object.keys(t.mermas).length}</th>
                        <th onClick={() => { this.openModalByType('devoluciones', t) }} style={{ textAlign: 'center', }}>{Object.keys(t.devoluciones).length}</th>
                        <th onClick={() => { this.openModalByType('traspasos', t) }} style={{ textAlign: 'center', }}>{Object.keys(t.traspasos).length}</th>
                      </tr>
                    ))
                  }
                  </tbody>
                </Table>
              </div>


              <Modal
                overlayClassName="Overlay__aplicaciones"
                isOpen={this.state.isOpenModal}
                onRequestClose={() => { this.setState({ isOpenModal: false}) }}
                style={customStyles}
                contentLabel=""
                >
                <div className="">
                  <Row className=""> 
                    <Col>
                      <h4 style={{ textAlign: 'center', }}>{infoModal.title}</h4>

                      {
                        infoModal.title === 'VENTAS' && Object.keys( infoModal.data ).length ? (
                          <> 
                            {
                              Object.keys(infoModal.data).map((t0,e0) => (
                                <>
                                  <Row>
                                    <Col>
                                      <p style={{ textAlign: 'left', fontWeight: 'bold', }}>Venta { moment(infoModal.data[t0][0].fecha_venta).format('HH:mm') }</p>
                                    </Col>
                                    {/*<Col>
                                      <Button style={{ textAlign: 'right', fontWeight: '300', }}>Devolución</Button>
                                      </Col>
                                    <Col>
                                      <Button style={{ textAlign: 'right', fontWeight: '300', }}>Eliminar venta</Button>
                                    </Col>*/}
                                  </Row>
                                  <hr />
                                  {
                                    <div className="table-responsive">
                                      <Table className="table table-sm table-striped mt-2">
                                        <thead>
                                          <tr>
                                            <td>Producto</td>
                                            <td>Precio compra</td>
                                            <td>Precio venta</td>
                                            <td>KG</td>
                                          </tr>
                                        </thead>

                                        <tbody>
                                        {
                                          infoModal.data[t0].map((t1,e1) => (
                                            <tr>
                                              <td>{t1.producto}</td>
                                              <td>{t1.venta_pcompra}</td>
                                              <td>{t1.venta_pesos}</td>
                                              <td>{t1.venta_kg}</td>
                                            </tr>
                                          ))
                                        }
                                        </tbody>
                                      </Table>
                                    </div>
                                  }
                                </>
                              ))
                            }

                          </>
                        ) : null
                      }

                      {
                        infoModal.title === 'CORTES' && infoModal.data.length >0 ? (
                          <>
                            {
                              <div className="table-responsive">
                                <Table className="table table-sm table-striped mt-2">
                                  <thead>
                                    <tr>
                                      <td>Observación</td>
                                      <td>Monto</td>
                                      <td>Fecha</td>
                                      <td>Opciones</td>
                                    </tr>
                                  </thead>

                                  <tbody>
                                  {
                                    infoModal.data.map((t1,e1) => (
                                      <tr>
                                        <td>{
                                          t1.observacion === '' && t1.valor < 0 ? 'Apertura del día' : t1.observacion
                                        }</td>
                                        <td>${this.number_format(t1.valor,2)}</td>
                                        <td>{moment(t1.created_at).format('HH:mm')}</td>
                                        {/*<td>Eliminar</td>*/}
                                      </tr>
                                    ))
                                  }
                                  </tbody>
                                </Table>
                              </div>
                            }
                          </>
                        ) : null
                      }

                      {
                        infoModal.title === 'MERMAS' && Object.keys( infoModal.data ).length ? (
                          <> 
                            {
                              Object.keys(infoModal.data).map((t0,e0) => (
                                <>
                                  <Row>
                                    <Col>
                                      <p style={{ textAlign: 'left', fontWeight: 'bold', }}>Venta { moment(infoModal.data[t0][0].fecha_venta).format('HH:mm') }</p>
                                    </Col>
                                    {/*<Col>
                                      <Button style={{ textAlign: 'right', fontWeight: '300', }}>Devolución</Button>
                                      </Col>
                                    <Col>
                                      <Button style={{ textAlign: 'right', fontWeight: '300', }}>Eliminar venta</Button>
                                    </Col>*/}
                                  </Row>
                                  <hr />
                                  {
                                    <div className="table-responsive">
                                      <Table className="table table-sm table-striped mt-2">
                                        <thead>
                                          <tr>
                                            <td>Producto</td>
                                            <td>Precio compra</td>
                                            <td>Precio venta</td>
                                            <td>KG</td>
                                          </tr>
                                        </thead>

                                        <tbody>
                                        {
                                          infoModal.data[t0].map((t1,e1) => (
                                            <tr>
                                              <td>{t1.producto}</td>
                                              <td>{t1.venta_pcompra}</td>
                                              <td>{t1.venta_pesos}</td>
                                              <td>{t1.venta_kg}</td>
                                            </tr>
                                          ))
                                        }
                                        </tbody>
                                      </Table>
                                    </div>
                                  }
                                </>
                              ))
                            }

                          </>
                        ) : null
                      }

                      {
                        infoModal.title === 'DEVOLUCIONES' && Object.keys( infoModal.data ).length ? (
                          <> 
                            {
                              Object.keys(infoModal.data).map((t0,e0) => (
                                <>
                                  <Row>
                                    <Col>
                                      <p style={{ textAlign: 'left', fontWeight: 'bold', }}>Venta { moment(infoModal.data[t0][0].fecha_venta).format('HH:mm') }</p>
                                    </Col>
                                    {/*<Col>
                                      <Button style={{ textAlign: 'right', fontWeight: '300', }}>Devolución</Button>
                                      </Col>
                                    <Col>
                                      <Button style={{ textAlign: 'right', fontWeight: '300', }}>Eliminar venta</Button>
                                    </Col>*/}
                                  </Row>
                                  <hr />
                                  {
                                    <div className="table-responsive">
                                      <Table className="table table-sm table-striped mt-2">
                                        <thead>
                                          <tr>
                                            <td>Producto</td>
                                            <td>Precio compra</td>
                                            <td>Precio venta</td>
                                            <td>KG</td>
                                          </tr>
                                        </thead>

                                        <tbody>
                                        {
                                          infoModal.data[t0].map((t1,e1) => (
                                            <tr>
                                              <td>{t1.producto}</td>
                                              <td>{t1.venta_pcompra}</td>
                                              <td>{t1.venta_pesos}</td>
                                              <td>{t1.venta_kg}</td>
                                            </tr>
                                          ))
                                        }
                                        </tbody>
                                      </Table>
                                    </div>
                                  }
                                </>
                              ))
                            }

                          </>
                        ) : null
                      }

                      {
                        infoModal.title === 'TRASPASOS' && Object.keys( infoModal.data ).length ? (
                          <> 
                            {
                              Object.keys(infoModal.data).map((t0,e0) => (
                                <>
                                  <Row>
                                    <Col>
                                      <p style={{ textAlign: 'left', fontWeight: 'bold', }}>Venta { moment(infoModal.data[t0][0].fecha_venta).format('HH:mm') }</p>
                                    </Col>
                                    {/*<Col>
                                      <Button style={{ textAlign: 'right', fontWeight: '300', }}>Devolución</Button>
                                      </Col>
                                    <Col>
                                      <Button style={{ textAlign: 'right', fontWeight: '300', }}>Eliminar venta</Button>
                                    </Col>*/}
                                  </Row>
                                  <hr />
                                  {
                                    <div className="table-responsive">
                                      <Table className="table table-sm table-striped mt-2">
                                        <thead>
                                          <tr>
                                            <td>Producto</td>
                                            <td>Precio compra</td>
                                            <td>Precio venta</td>
                                            <td>KG</td>
                                          </tr>
                                        </thead>

                                        <tbody>
                                        {
                                          infoModal.data[t0].map((t1,e1) => (
                                            <tr>
                                              <td>{t1.producto}</td>
                                              <td>{t1.venta_pcompra}</td>
                                              <td>{t1.venta_pesos}</td>
                                              <td>{t1.venta_kg}</td>
                                            </tr>
                                          ))
                                        }
                                        </tbody>
                                      </Table>
                                    </div>
                                  }
                                </>
                              ))
                            }

                          </>
                        ) : null
                      }

                    </Col>
                  </Row>
                </div>
              </Modal>

            </div>
          </Col>
        </Row>
      </div>
    )
  }

  getGastosFinancieros() {
    const { finit, ffin, } = this.state
    this.setState({ isLoading: true, })

    const data = { finit, ffin, }
    fetch(`${URL}/controllerWebApp.php?opt=getGastosFinancieros`, {
      method: "POST", mode: "cors",
      body: JSON.stringify(data),
    }).then((res) => res.json())
    .then((res) => {
      this.autocompleteGastos(res)
    }).catch(e => {})
  }

  autocompleteGastos(res) {
    let { arrGastosFinancieros } = res
    let cantidadEfectivo = 0,
    cantidadTD = 0,
    cantidadTC = 0,
    cantidadTotal = 0,
    cantidadFacturado = 0,
    cantidadSinFacturar = 0

    arrGastosFinancieros.map((t,e) => {

      if(t.forma_pago === 1)
        cantidadEfectivo += parseFloat(t.cantidad)
      else if(t.forma_pago === 2)
        cantidadTD += parseFloat(t.cantidad)
      else if(t.forma_pago === 3)
        cantidadTC += parseFloat(t.cantidad);

      if(t.facturado == 0)
        cantidadSinFacturar += parseFloat(t.cantidad);
      else if(t.facturado == 1)
        cantidadFacturado += parseFloat(t.cantidad);

      cantidadTotal += parseFloat(t.cantidad)
    })

    this.setState({ isLoading: false, ...res, cantidadEfectivo, cantidadTD, cantidadTC, cantidadTotal, cantidadFacturado, cantidadSinFacturar, })
  }

  onDeleteGastoFinanciero(item) {
    fetch("https://hg.wsoft.com.mx/REST/controllers/controllerWebApp.php?opt=setDeleteGastoFinanciero",
      this.headersPOST({ id_gasto: item.id_gasto, })
    ).then(response => response.json())
    .then((response) => {
      alert('Gasto eliminado con éxito.')
      window.location.reload()
    })
  }

  handleCloseModal = (type) => {
    this.setState({ [type]: false, });
  }

  makeViewFinancieros() {
    const { date, arrSucursales, showModalActivity, arrGFinancieroNew, arrConceptosGFinancieros,
      arrGastosFinancieros, viewOnlyForm,cantidadFacturado, cantidadSinFacturar, cantidadTC, cantidadEfectivo, cantidadTD, finit, ffin,
    } = this.state;

    let totalSuma = 0
    const elementsHtmlGF = arrGastosFinancieros.map((t, e) => {
      totalSuma += parseFloat(t.cantidad)
      return (
        <tr key={"row_" + e}>
          <td style={{ padding: 20, }} className="cell">{ t.sucursal }</td>
          <td style={{ padding: 20, }} className="cell">{ t.descripcion }</td>
          <td style={{ padding: 20, }} className="cell">{ t.concepto }</td>
          <td style={{ padding: 20, }} className="cell">{ t.forma_pago_texto }</td>
          <td style={{ padding: 20, }} className="cell">{
            t.edit ? (
              <button className={'btn btn-secondary'} onClick={() => {
                arrGastosFinancieros[e].facturado = arrGastosFinancieros[e].facturado === 1 ? false : true
                arrGastosFinancieros[e].facturado_texto = arrGastosFinancieros[e].facturado_texto === 'SI' ? 'NO' : 'SI'
                this.setState({ arrGastosFinancieros, })
              }}>{t.facturado_texto}</button>
            ) : (
              <p className="mb-0"><b>{t.facturado_texto}</b></p>
            )
          }</td>
          <td style={{ padding: 20, }} className="cell">{
            t.edit ? (
              <input type={'text'}
                value={t.cantidad}
                onChange={(ev) => {
                  arrGastosFinancieros[e].cantidad = ev.target.value
                  this.setState({ arrGastosFinancieros, })
                }}
              /> 
            ) : <p className="mb-0"><b>{this.number_format(t.cantidad,2)}</b></p>
          }</td>
          <td style={{ padding: 20, }} className="cell">{moment(t.created_at).format('DD/MM HH:mm')}</td>
          <td style={{ padding: 20, }} className="cell">{
            t.edit ? (
              <p onClick={() => {
                arrGastosFinancieros[e].edit = !arrGastosFinancieros[e].edit
                this.setState({ arrGastosFinancieros, })
                this.onChangeValueRegistro(arrGastosFinancieros[e])
              }} className="mb-0 btn btn-primary">Aplicar</p>
            ) : (
            <div>
              <p onClick={() => {

                arrGastosFinancieros[e].edit = !arrGastosFinancieros[e].edit
                this.setState({ arrGastosFinancieros, })

              }} className="mb-0 btn btn-info">Editar</p>
              <p onClick={() => { this.onDeleteGastoFinanciero(t) }} className="mb-0 btn btn-danger">Eliminar</p>
            </div>
            )
          }</td>
        </tr>
      );
    });

    return (
      <div style={{ background: '#fff', borderRadius: 4, padding: 10, }}>

        <div className={'row facturacionContersData'}>
          <div className={'col'}>
            <p className={'ws__totalTitle'}>Facturado</p>
            <p className={'ws__totalCantidad'}>${this.number_format(cantidadFacturado, 2)}</p>
          </div>
          <div className={'col'}>
            <p className={'ws__totalTitle'}>Sin facturar</p>
            <p className={'ws__totalCantidad'}>${this.number_format(cantidadSinFacturar, 2)}</p>
          </div>
          <div className={'col'}>
            <p className={'ws__totalTitle'}>Efectivo</p>
            <p className={'ws__totalCantidad'}>${this.number_format(cantidadEfectivo, 2)}</p>
          </div>
          <div className={'col'}>
            <p className={'ws__totalTitle'}>Tarjetas</p>
            <p className={'ws__totalCantidad'}>${this.number_format(cantidadTC + cantidadTD, 2)}</p>
          </div>
          <div className={'col'}>
            <p className={'ws__totalTitle'}>Total</p>
            <p className={'ws__totalCantidad'}>${this.number_format(cantidadTC + cantidadEfectivo + cantidadTD, 2 )}</p>
          </div>
        </div>

        <hr />

        <div className="ws_tab_box">
          <div className="ws_tb_responsive">

            <Row style={{ padding: 5, }}>
              <Col>
                <p style={{ margin: 0, }}>Desde</p>
                <input type={"date"}
                  value={finit}
                  onChange={(event) => {
                    this.setState({ finit: event.target.value, });
                  }}
                  style={{background: '#f3f3f3', border: '3px solid #F3F3F4', margin: 0, width: '100%', }}
                />
              </Col>
              <Col>
                <p style={{ margin: 0, }}>Hasta</p>
                <input type={"date"}
                  value={ffin}
                  onChange={(event) => {
                    this.setState({ ffin: event.target.value, });
                  }}
                  style={{background: '#f3f3f3', border: '3px solid #F3F3F4', margin: 0, width: '100%', }}
                />
              </Col>

              <Col>
                <button style={{ margin: 0, marginTop: 5, }} className={'btn btn-primary'} onClick={() => { this.getGastosFinancieros() }}>Generar</button>
              </Col>
            </Row>
          </div>
        </div>

        <Row>
          <Col>
            <div className="directorPage__wrapper"  style={{ paddingBottom: 20, background: 'transparent', position: 'inherit', zIndex: 0, }}>
              <div className="examples">
                <div className="basic">
                  <div className={'btn-new'}>
                    <button onClick={() => { this.setState({ showModalActivity: true, }) }} className={'btn btn-secondary'}>Nuevo</button>
                  </div>
                  <table className="basic-table" style={{ width: '100%', }}>
                    <thead>
                      <TableFilter
                        rows={arrGastosFinancieros}
                        onFilterUpdate={this._filterUpdatedGF}
                      >
                        <th style={{ padding: 20, }} key="sucursal" filterkey="sucursal" className="cell" casesensitive={"true"} showsearch={"true"}>Sucursal</th>
                        <th style={{ padding: 20, }} key="descripcion" filterkey="descripcion" className="cell" casesensitive={"true"} showsearch={"true"}>Descripción</th>
                        <th style={{ padding: 20, }} key="concepto" filterkey="concepto" className="cell" casesensitive={"true"} showsearch={"true"}>Concepto</th>
                        <th style={{ padding: 20, }} key="forma_pago" filterkey="forma_pago" className="cell" casesensitive={"true"} showsearch={"true"}>Forma de pago</th>
                        <th style={{ padding: 20, }} key="facturado" filterkey="facturado" className="cell" casesensitive={"true"} showsearch={"true"}>Facturado</th>
                        <th style={{ padding: 20, }} key="cantidad" filterkey="cantidad" className="cell" casesensitive={"true"} showsearch={"true"}>Cantidad</th>
                        <th style={{ padding: 20, }} key="fecha" filterkey="fecha" className="cell" casesensitive={"true"} showsearch={"true"}>Fecha</th>
                        <th style={{ padding: 20, }} key="op" filterkey="op" className="cell" casesensitive={"true"} showsearch={"true"}>Op</th>
                      </TableFilter>
                    </thead>
                    <tbody>{elementsHtmlGF}</tbody>
                  </table>
                  <h5 className="header" style={{ textAlign: 'center', }}>Tota: ${this.number_format(totalSuma)}</h5>
                </div>
              </div>
            </div>
          </Col>
        </Row>

        <Modal
          overlayClassName="Overlay__aplicaciones"
          isOpen={showModalActivity}
          onRequestClose={() => { this.setState({ showModalActivity: false}) }}

          contentLabel=""
        >
          <h4 style={{ textAlign: 'center', }}>Registrar nuevo gasto</h4>
          <Container>
            <Row>
              <Col>
                <div>
                  <div className="form-group">
                    <p style={{ fontSize: '1rem' }}>Ingresa la descripción del gasto</p>
                    <textarea className={'usersPage__modalNewName'} style={{ margin: 0, width: '100%', background: '#f3f3f3', border: 0, minHeight: 100, }}
                      placeholder={'Ingresa una descripción aquí...'}
                      value={ arrGFinancieroNew.descripcion }
                      onChange={(event) => {
                        arrGFinancieroNew.descripcion = event.target.value;
                        this.setState({ arrGFinancieroNew, })
                      }}
                    ></textarea>
                  </div>
                  <div className="form-group">
                    <p style={{ fontSize: '1rem' }}>Selecciona el concepto</p>
                    <select className={'ws__list_meta_select'} onChange={ (e) => { arrGFinancieroNew.id_concepto = e.target.value; this.setState({ arrGFinancieroNew, }) }}>
                      <option value={0} disabled selected>Selecciona una opción</option>
                      { arrConceptosGFinancieros.map((t,e) => (
                        <option key={e} value={t.id_concepto}>{t.concepto}</option>
                      )) }
                    </select>
                  </div>
                  <div className="form-group">
                    <label className="control-label h5">Sucursal</label>
                    <select className={'ws__list_meta_select'} onChange={(ev) => { this.setState({ id_sucursal: ev.target.value, }) }}>
                      <option disabled="disabled" selected="selected">Selecciona una sucursal</option>
                      { arrSucursales.map((t,e) => (
                          <option key={e} value={t.id_sucursal}>{t.nombre}</option>
                      )) }
                    </select>
                  </div>
                  <div className="form-group">
                    <p style={{ fontSize: '1rem' }}>Selecciona la fecha</p>
                    <input className={'usersPage__modalNewName'} style={{ margin: 0, }} type={'date'}
                      value={ arrGFinancieroNew.date }
                      onChange={(event) => {
                        arrGFinancieroNew.date = event.target.value;
                        this.setState({ arrGFinancieroNew, })
                      }}
                    />
                  </div>
                  <div className="form-group">
                    <p style={{ fontSize: '1rem' }}>Ingresa la cantidad</p>
                    <input className={'usersPage__modalNewName'} style={{ margin: 0, }} type={'text'}
                    value={ arrGFinancieroNew.cantidad }
                    onChange={(event) => {
                      arrGFinancieroNew.cantidad = event.target.value;
                      this.setState({ arrGFinancieroNew, })
                    }}
                  />
                  </div>
                  <div className="form-group">
                    <p style={{ fontSize: '1rem' }}>Ya facturado</p>
                    <button className={'btn btn-secondary'} onClick={() => {
                      arrGFinancieroNew.facturado = !arrGFinancieroNew.facturado;
                      this.setState({ arrGFinancieroNew, });
                    }} >{arrGFinancieroNew.facturado ? 'Si' : 'No'}</button>
                  </div>
                  <div className="form-group">
                    <p style={{ fontSize: '1rem' }}>¿Es gasto?</p>
                    <button className={'btn btn-secondary'} onClick={() => {
                      arrGFinancieroNew.esGasto = !arrGFinancieroNew.esGasto;
                      this.setState({ arrGFinancieroNew, });
                    }} >{arrGFinancieroNew.esGasto ? 'Si' : 'No'}</button>
                  </div>
                  <div className="form-group">
                    <p style={{ fontSize: '1rem' }}>Forma de pago</p>
                    <select className={'ws__list_meta_select'} onChange={ (e) => { arrGFinancieroNew.forma_pago = e.target.value; this.setState({ arrGFinancieroNew, }) }}>
                      <option value={0} disabled selected>Selecciona una opción</option>
                      <option value={1}>Efectivo</option>
                      <option value={2}>Tarjeta de débito</option>
                      <option value={3}>Tarjeta de crédito</option>
                      <option value={4}>Transferencia electrónica</option>
                    </select>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
          <div style={{ textAlign: 'center', }}>
            <Button variant="primary" onClick={() => this.onRegisterNewGastoFinanciero() }>Registrar gasto</Button>
          </div>
        </Modal>

      </div>
    )
  }

  onChangeValueRegistro(item) {
    fetch("https://hg.wsoft.com.mx/REST/controllers/controllerWebApp.php?opt=setUpdateGastoFinanciero",
      this.headersPOST({ ...item, })
    ).then(response => response.json())
    .then((response) => {
      alert('Gasto actualizado con éxito.')
    })
  }

  onRegisterNewGastoFinanciero() {
    let { arrGFinancieroNew, finit, ffin, id_sucursal, } = this.state
    const { id_concepto, cantidad, facturado, forma_pago, } = arrGFinancieroNew
    // const { signedIn, } = this.props.initState

    if( !id_concepto || !cantidad || !forma_pago ) {
      alert('Por favor, ingresa todos los campos solicitados.');
      return false
    }

    fetch("https://hg.wsoft.com.mx/REST/controllers/controllerWebApp.php?opt=setRegisterGastoFinanciero",
      this.headersPOST({ ...arrGFinancieroNew, id_usuario: 'wiwi00_adm', finit, ffin, id_sucursal, })
    ).then(response => response.json())
    .then((response) => {
      this.autocompleteGastos(response)
      // this.setState({ ...response, })
      this.handleCloseModal('showModalActivity')
      alert('Gasto registrado con éxito.')
    })
  }

  makeConceptoCaja(id_motivo) {
    if(id_motivo === 0) return 'Apertura del día';
    else if(id_motivo === 1) return 'Retiro de efectivo';
    else if(id_motivo === 3) return 'A solicitud de oficina';
    else if(id_motivo === 4) return 'Pago a proveedor';
    else if(id_motivo === 6) return 'Gasto fijo diario';
    else
      return ''
  }

  makeViewFacturas() {
    const {
      arrayListFacturas,
    } = this.state

    return (
      <div className={'ws_tabs_cajero'}>
        <Row style={{ width: '99%', margin: '0 auto' }}>
          <Col style={{ background: '#fff', padding: 15, }} className={'z-depth-1'}>
            <Row>
              <Col xs={'3'}>
                <b>CLIENTE</b>
              </Col>
              <Col xs={'2'}>
                <b>SUCURSAL</b>
              </Col>
              <Col xs={'2'}>
                <b>TELEFONO</b>
              </Col>
              <Col xs={'2'}>
                <b>DIRECCION</b>
              </Col>
              <Col xs={'2'}>
                <b>FECHA</b>
              </Col>
              <Col xs={'1'}>
                <b>ESTATUS</b>
              </Col>
            </Row>
            {
              arrayListFacturas.map((t, e) => (
                <Row
                  onClick={() => {
                    this.onSelectFacturaInformacion(e)
                  }}
                  key={`ws_list_compra_${e}`}
                  style={{ width: '100%', margin: '0 auto', marginTop: 10, marginBottom: 10, }}
                  className={`regControlProductoPage__content`}
                >
                  <Col xs={'3'} className="regVentaPage__listProduct">
                    <p style={{ color: '#333' }}>{t.nombreCliente}</p>
                    <p style={{ color: '#333' }}>{t.email}</p>
                  </Col>
                  <Col xs={'2'} className="regVentaPage__listProduct">
                    <p style={{ color: '#333' }}>{t.sucursal}</p>
                  </Col>
                  <Col xs={'2'} className="regVentaPage__listProduct">
                    <p style={{ color: '#333' }}>{t.telefono}</p>
                  </Col>
                  <Col xs={'2'} className="regVentaPage__listProduct">
                    <p style={{ color: '#333' }}>
                      {`
                      ${t.direccion_calle !== '' ? t.direccion_calle : ''}
                      ${t.direccion_colonia !== '' ? t.direccion_colonia : ''}
                      ${t.direccion_noext !== '' ? t.direccion_noext : ''}
                      ${t.direccion_noint !== '' ? t.direccion_noint : ''}
                      ${t.direccion_cp !== '' ? t.direccion_cp : ''}
                      ${t.direccion_ciudad !== '' ? t.direccion_ciudad : ''}
                      ${t.direccion_estado !== '' ? t.direccion_estado : ''}
                    `}

                    </p>
                  </Col>
                  <Col xs={'2'} className="regVentaPage__listProduct">
                    <TimeAgo style={{ color: '#444', }} className="__listViewPending_time" date={t.created_at} formatter={formatter} />
                  </Col>
                  <Col xs={'1'} className="regVentaPage__listProduct">
                    <Badge color={'danger'}>{t.status === 0 ? 'CANCELADA' : null}</Badge>
                    <Badge color={'warning'}>{t.status === 1 ? 'PENDIENTE' : null}</Badge>
                    <Badge color={'success'}>{t.status === 2 ? `FACTURADO` : null}</Badge>
                  </Col>
                </Row>
              ))
            }
          </Col>
        </Row>
      </div>
    )
  }

  setEmitFactura() {
    const {
      arrayListFacturas,
      indexFactura,
    } = this.state
    const info = arrayListFacturas[indexFactura]
    fetch(this.getURLByOPT('setEmitFactura'), this.headersPOST({ id_facturacion: info.id_facturacion }))
      .then(response => response.json())
      .then((response) => {
        this.setState({
          view: 'list_facturas',
        })

        this.getListFacturacion()
      }).catch(() => { })
  }

  makeViewFacturaInformation() {
    const {
      arrayListFacturas,
      indexFactura,
    } = this.state
    const info = arrayListFacturas[indexFactura]

    let grandTotal = 0
    if (info.arr.length > 0) {
      info.arr.map((t) => { grandTotal += (t.total) })
    }
    return (
      <div className={'facturacionBody'}>
        <Row style={{ width: '99%', margin: '0 auto' }}>
          <Col style={{ background: '#fff', padding: 15, }} className={'z-depth-1'}>
            <Row>
              <Col>
                <h4 style={{ cursor: 'pointer', }} onClick={() => { this.setState({ view: 'list_facturas', }) }}>Regresar</h4>
                <h4>Información fiscal</h4>
                <Row>
                  <Col>
                    <p style={{ margin: 0, }}>Razón social</p>
                    <input style={{ width: '100%', marginBottom: 10, }} type="text" disabled={"disabled"} value={info.razon_social} />
                  </Col>
                  <Col>
                    <p style={{ margin: 0, }}>RFC</p>
                    <input style={{ width: '100%', marginBottom: 10, }} type="text" disabled={"disabled"} value={info.rfc} />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <p style={{ margin: 0, }}>Teléfono</p>
                    <input style={{ width: '100%', marginBottom: 10, }} type="text" disabled={"disabled"} value={info.telefono} />
                  </Col>
                  <Col>
                    <p style={{ margin: 0, }}>Correo electrónico</p>
                    <input style={{ width: '100%', marginBottom: 10, }} type="text" disabled={"disabled"} value={info.email} />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <p style={{ margin: 0, }}>Calle</p>
                    <input style={{ width: '100%', marginBottom: 10, }} type="text" disabled={"disabled"} value={info.direccion_calle} />
                  </Col>
                  <Col>
                    <p style={{ margin: 0, }}>Colonia</p>
                    <input style={{ width: '100%', marginBottom: 10, }} type="text" disabled={"disabled"} value={info.direccion_colonia} />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <p style={{ margin: 0, }}>Nº Exterior</p>
                    <input style={{ width: '100%', marginBottom: 10, }} type="text" disabled={"disabled"} value={info.direccion_noext} />
                  </Col>
                  <Col>
                    <p style={{ margin: 0, }}>Nº Interior</p>
                    <input style={{ width: '100%', marginBottom: 10, }} type="text" disabled={"disabled"} value={info.direccion_noint} />
                  </Col>
                  <Col>
                    <p style={{ margin: 0, }}>Código postal</p>
                    <input style={{ width: '100%', marginBottom: 10, }} type="text" disabled={"disabled"} value={info.direccion_cp} />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <p style={{ margin: 0, }}>Ciudad</p>
                    <input style={{ width: '100%', marginBottom: 10, }} type="text" disabled={"disabled"} value={info.direccion_ciudad} />
                  </Col>
                  <Col>
                    <p style={{ margin: 0, }}>Estado</p>
                    <input style={{ width: '100%', marginBottom: 10, }} type="text" disabled={"disabled"} value={info.direccion_estado} />
                  </Col>
                </Row>
                <Row>
                  <button
                    onClick={() => {
                      this.setEmitFactura()
                    }}
                    className={'btn btn-primary'}
                  >Factura realizada</button>
                </Row>
              </Col>

              <Col>
                <h4>Recibos:</h4>

                <div>
                  {
                    info.arr.map((t, e) => this.makeInfoArr(t, e))
                  }
                  <b>GRAND TOTAL ${this.number_format(grandTotal, 2)}</b>
                </div>

              </Col>
            </Row>

          </Col>
        </Row>
      </div>
    )
  }

  makeInfoArr(t, e) {
    if (t.listado.length === 0) {
      return null
    }

    return (
      <div style={{ marginBottom: 20, }}>
        <Row>
          <Col>Producto</Col>
          <Col>Cantidad</Col>
          <Col>Total</Col>
        </Row>
        {
          t.listado.map((t0, e0) => (
            <Row>
              <Col>{t0.nombre}</Col>
              <Col>{this.number_format(t0.venta_kg, 2)}</Col>
              <Col>${this.number_format(t0.venta_pesos, 2)}</Col>
            </Row>
          ))
        }
        <div>
          <b>Total ${this.number_format(t.total, 2)}</b>
        </div>
      </div>
    )
  }

  updateSucursalCajero(id_sucursal,id_usuario) {
    console.log("update", id_sucursal)
    fetch(this.getURLByOPT('setUpdateCajeroSucursal'), this.headersPOST({id_usuario , id_sucursal}))
      .then(response => response.json())
      .then((response) => {
        alert("CAJERO CAMBIADO CON EXITO, NOTA: ES NECESARIO VOLVER A INICIAR SESIÓN PARA QUE EL CAMBIO SE VEA APLICADO")
        this.setState({
          arrayListCajeros: { list: [], sucursales_disponibles: [] }
        })
        this.getListCajeros()
      }).catch(() => { })
  }

  getListFacturacion() {
    fetch(this.getURLByOPT('getListFacturacion'), this.headersPOST({}))
      .then(response => response.json())
      .then((response) => {
        this.setState({ arrayListFacturas: response, })
      }).catch(() => { })
  }

  getListCajeros() {
    fetch(this.getURLByOPT('getListCajerosFromChange'), this.headersPOST({}))
      .then(response => response.json())
      .then((response) => {
        this.setState({ arrayListCajeros: response, })
      }).catch(() => { })
  }

  onSelectFacturaInformacion(e) {
    this.setState({
      indexFactura: e,
      view: 'factura_view',
    })

    fetch(this.getURLByOPT('getInfoVentas'), this.headersPOST({ id_facturacion: this.state.arrayListFacturas[e].id_facturacion }))
      .then(response => response.json())
      .then((response) => {
        let arrayListFacturas = this.state.arrayListFacturas
        arrayListFacturas[e].arr = response
        this.setState({ arrayListFacturas })
      }).catch(() => { })
  }

  /** CAJA **/
  generateListCaja(date) {
    if(!date)
      date = this.state.dateCaja

    fetch(this.getURLByOPT('getHistoryCaja'), this.headersPOST({ date, }))
      .then(response => response.json())
      .then((response) => {
        this.setState({ arrayListCaja: response, })
      }).catch(() => { })
  }

  setDeleteCajaRH(item) {
    fetch(this.getURLByOPT('setDeleteCajaRH'), this.headersPOST({ ...item, }))
      .then(response => response.json())
      .then((response) => {
        alert('Notificado con éxito')
        this.generateListCaja()
      }).catch(() => { })
  }

  /** CAJA **/

  getURLByOPT(opt) {
    let PHP = this.props.initState.debug === 1 ? 'controllerPreproduction.php' : 'controllerWebApp.php'
    return `https://hg.wsoft.com.mx/REST/controllers/${PHP}?opt=${opt}`
  }

  initsetState(param) {
    this.props.initsetState(param)
    return true
  }

  headersPOST(data) {
    return {
      method: "POST",
      mode: "cors",
      body: JSON.stringify(data),
    }
  }

  getStyleModal(opt) {
    if (opt === 'isOpenListVentaByID') {
      return { content: { top: '50%', left: '50%', right: 'auto', bottom: 'auto', marginRight: '-50%', transform: 'translate(-50%, -50%)', width: '50%', height: '50%', } };
    }

    return { content: { top: '50%', left: '50%', right: 'auto', bottom: 'auto', marginRight: '-50%', transform: 'translate(-50%, -50%)', width: '80%', height: '80%', } };
  }

  number_format(number, decimals, decPoint, thousandsSep) {
    number = (number + '').replace(/[^0-9+\-Ee.]/g, '')
    var n = !isFinite(+number) ? 0 : +number
    var prec = !isFinite(+decimals) ? 0 : Math.abs(decimals)
    var sep = (typeof thousandsSep === 'undefined') ? ',' : thousandsSep
    var dec = (typeof decPoint === 'undefined') ? '.' : decPoint
    var s = ''
    var toFixedFix = function (n, prec) {
      var k = Math.pow(10, prec)
      return '' + (Math.round(n * k) / k)
        .toFixed(prec)
    }
    s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.')
    if (s[0].length > 3) {
      s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep)
    }
    if ((s[1] || '').length < prec) {
      s[1] = s[1] || ''
      s[1] += new Array(prec - s[1].length + 1).join('0')
    }
    return s.join(dec)
  }

  uniqid() {
    var pr = '', en = false, result; this.seed = function (s, w) { s = parseInt(s, 10).toString(16); return w < s.length ? s.slice(s.length - w) : (w > s.length) ? new Array(1 + (w - s.length)).join('0') + s : s; }; result = pr + this.seed(parseInt(new Date().getTime() / 1000, 10), 8) + this.seed(Math.floor(Math.random() * 0x75bcd15) + 1, 5); if (en) { result += (Math.random() * 10).toFixed(8).toString(); } return result;
  }

};

export default withRouter(RHContadorPage)